import React from 'react';
import DefaultView from './DefaultView';
import useContacts from '../contacts/useContacts';

/**
 * @param {{
 *   contact: import('../Kalkhoff').SparseContact,
 * }} arg React props
 * @returns {JSX.Element} ...
 */
function Contact({ contact }) {
  const line1 = [
    contact.kalkhoff_location_address_1,
    contact.kalkhoff_location_address_2,
    contact.kalkhoff_location_address_3,
  ].filter((l) => !!l).join(', ');
  const line2 = [
    contact.kalkhoff_location_zip,
    contact.kalkhoff_location_country,
  ].filter((l) => !!l).join(', ');
  return <article className="contacts-list__contact">
    <h3 className="contacts-list__title">{
      contact.kalkhoff_location_title
    }</h3>
    <p className="contacts-list__adress1">{ line1 }</p>
    <p className="contacts-list__adress2">{ line2 }</p>
    { contact.kalkhoff_location_phone && (
      <a
        className="contacts-list__phone"
        href={ `tel:${contact.kalkhoff_location_phone}` }
      >{ contact.kalkhoff_location_phone }</a>
    ) }
    { contact.kalkhoff_location_fax && (
      <a
        className="contacts-list__fax"
        href={ `tel:${contact.kalkhoff_location_fax}` }
      >{ contact.kalkhoff_location_fax }</a>
    ) }
  </article>;
}

/**
 * @param {{
 *   country: string,
 *   contacts: import('../Kalkhoff').SparseContact[],
 * }} arg React props
 * @returns {JSX.Element} ...
 */
function Country({ country, contacts }) {
  const countryContacts = contacts.filter(
      (contact) => contact.kalkhoff_location_country === country,
  );
  return (
    <li className="countries-list__country">
      <h2 className="countries-list__title">{ country }</h2>
      <ol className="contacts-list">
        { countryContacts.map((contact) => (
          <Contact
            contact={ contact }
            key={ contact.kalkhoff_location_zip }
          />
        )) }
      </ol>
    </li>
  );
}

/**
 * @param {{
 *   page: import('../Kalkhoff').Page,
 *   offline: boolean,
 * }} arg React props
 * @returns {JSX.Element} ...
 */
export default function ContactView({ page, offline }) {
  const [ contacts ] = useContacts(page);

  const countries = contacts.reduce((acc, contact) => (
    acc.includes(contact.kalkhoff_location_country) ? acc : [
      ...acc,
      contact.kalkhoff_location_country,
    ]
  ), []);

  return <DefaultView page={ page } offline={ offline }>
    <ol className="countries-list">
      { countries.map((country) => (
        <Country country={ country } contacts={ contacts } key={ country } />
      )) }
    </ol>
  </DefaultView>;
}
